import { otp } from "@api/auth/otp/path";
import { token } from "@api/auth/token/path";

export const auth = {
  otp,
  token,
};
